import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {history} from "_helpers";
import {userInviteActions} from "_actions";
import {Loading} from "../../../../common";

export default function UserInviteCallback() {
    const dispatch = useDispatch();
    const url = new URL(document.location);
    const searchParams = new URLSearchParams(url.search);
    const inviteCode = searchParams.get('code');

    useEffect(() => {
        const key = `accepted-invite-${inviteCode}`;
        const alreadyAccepted = sessionStorage.getItem(key);

        if (inviteCode && !alreadyAccepted) {
            dispatch(userInviteActions.accept({ inviteCode }));
            sessionStorage.setItem(key, 'true');
        }
    }, [inviteCode, dispatch]);

    const userInvite = useSelector((state) => state.userInvite);
    const loadingAccept = userInvite.loadingAccept;
    const loadingUser = useSelector((state) => state.users?.loading);
    const { acceptInvite, acceptInviteError } = userInvite || {};

    const isSuccess = acceptInvite?.success === true;
    const error = acceptInviteError?.success === false && !!acceptInviteError.message;

    useEffect(() => {
        if (!loadingAccept && error) {
            history.push('/invalid-invite');
        }
    }, [loadingAccept, error, isSuccess]);

    if (loadingAccept || loadingUser) {
        return <Loading sx={{ backgroundColor: '#edede4' }} label="Processing invite..." />;
    }

    return null;
}